<ng-template #massiveSendModal let-modal>
  <div class="modal-header border-bottom-0">
    <h5 class="modal-title">{{ 'EXPORT.MASSIVESEND.TITLE' | translate }}</h5>
    <div id="closeModal">
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click');">
        <span aria-hidden="true">&times;</span>&nbsp;
        <span>{{ 'COMMON.CLOSE' | translate }}</span>
      </button>
    </div>
  </div>

  <div class="modal-body">
    <div class="container my-3">

      <div *ngIf="step === 'instructions'" class="form-group">
        <div class="row">
            <div class="col-12">
              <div class="alert alert-warning" role="alert" [innerHtml]="'EXPORT.MASSIVESEND.INSTRUCTIONS' | translate"></div>
            </div>
        </div>

        <hr class="my-4">

        <div class="row">
          <button type="button" class="btn btn-light mr-3" (click)="modal.dismiss('cancel click')">
            {{ 'COMMON.CANCEL' | translate }}
          </button>
          <button type="button" class="btn btn-primary" (click)="confirm()">
            {{ 'COMMON.CONFIRM' | translate }}
          </button>
        </div>
      </div>

      <div id="uploadProgress" class="my-3" *ngIf="step === 'uploadProgress'">
        <div class="card mb-4 border-0 shadow-sm">
          <div class="card-body text-center p-5">
            <ngb-progressbar type="primary" height="20px" [striped]="true" [animated]="true" [value]="uploadProgress()">{{ uploadProgress() | number:'1.0-0' }}%</ngb-progressbar>
            <h4 class="mt-5 mb-3">{{ 'CANDIDATES.ESTIMATEDTIME' | translate }}: {{ estimatedTime() }}</h4>
            <h4>{{ 'COMMON.CANDIDATES' | translate }}: {{ totalInvited }}/{{ totalInvitations }}</h4>
          </div>
        </div>
      </div>

      <div id="uploadResume" class="my-3" *ngIf="step === 'uploadResume'">
        <div class="card mb-4 border-0 shadow-sm">
          <div class="card-body text-center p-5">
            <div class="resume-icons">
              <i class="fa fa-check-circle fa-5x text-success"></i><span>{{ totalInvited - errorEmails.length }}</span>
              <i class="fa fa-close fa-5x ml-5 text-danger"></i><span>{{ errorEmails.length }}</span>
            </div>

            <div>
              <ul class="list-group list-group-flush">
                <li class="list-group-item" *ngFor="let email of errorEmails">{{ email }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</ng-template>
